"use client";

import UpcomingEvents from "@/modules/events/components/upcoming-events";

export default function Events() {
	return (
		<div className="mt-6 flex items-center justify-center py-12 md:mt-16 md:py-12">
			<div className="mx-auto w-11/12 max-w-7xl md:w-full">
				<UpcomingEvents />
			</div>
		</div>
	);
}
